import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.services": "Services",
      "nav.penetration": "Penetration Testing",
      "nav.threatMap": "Threat Map",
      "nav.blog": "Blog",
      "nav.contact": "Contact",
      
      // Hero Section
      "hero.title": "Protecting Your Digital Assets",
      "hero.titleHighlight": "With Excellence",
      "hero.subtitle": "Leading cybersecurity solutions powered by innovation, reliability, and global expertise. Trusted by enterprises worldwide.",
      "hero.cta1": "Get Started",
      "hero.cta2": "Explore Services",
      
      // Stats
      "stats.clients": "Clients Protected",
      "stats.detection": "Threat Detection",
      "stats.countries": "Countries Served",
      "stats.monitoring": "Security Monitoring",
      
      // About Section
      "about.title": "About SULH Cybersecurity",
      "about.desc1": "We are a globally recognized cybersecurity firm committed to protecting enterprises from evolving digital threats. As a TSE-integrated company, we maintain the highest standards of security and compliance.",
      "about.desc2": "Our ISO 27001 certification demonstrates our commitment to information security management, while our compliance with PCI DSS and GDPR ensures we meet international regulatory standards.",
      "about.desc3": "Collaborating with leading international cybersecurity partners, we deliver cutting-edge solutions that protect your business infrastructure, data, and reputation.",
      "about.cta": "Partner With Us",
      "about.commitment": "Our Commitment",
      "about.cert1": "ISO 27001 Certified Excellence",
      "about.cert2": "TSE-Integrated Operations",
      "about.cert3": "PCI DSS Compliant Solutions",
      "about.cert4": "GDPR Data Protection",
      "about.cert5": "Global Partnership Network",
      
      // Services
      "services.title": "Our Services",
      "services.subtitle": "Comprehensive cybersecurity solutions tailored to protect your organization",
      "services.pentest": "Penetration Testing",
      "services.pentestDesc": "Comprehensive security assessments to identify vulnerabilities before attackers do.",
      "services.siem": "SIEM Solutions",
      "services.siemDesc": "Real-time security monitoring and event management for threat detection.",
      "services.idsips": "IDS/IPS",
      "services.idsipsDesc": "Advanced intrusion detection and prevention systems for network security.",
      "services.vuln": "Vulnerability Assessment",
      "services.vulnDesc": "Systematic evaluation of security weaknesses in your infrastructure.",
      "services.training": "Security Awareness Training",
      "services.trainingDesc": "Empower your team with knowledge to prevent social engineering attacks.",
      "services.malware": "Reverse Engineering & Malware Analysis",
      "services.malwareDesc": "Advanced threat analysis to identify and neutralize sophisticated malware.",
      "services.learnMore": "Learn More About Our Services",
      
      // Certifications
      "cert.title": "Compliance & Certifications",
      "cert.subtitle": "Meeting the highest international standards for cybersecurity and data protection",
      "cert.iso": "ISO 27001",
      "cert.isoDesc": "Information Security Management",
      "cert.tse": "TSE Integration",
      "cert.tseDesc": "Turkish Standards Institute",
      "cert.pci": "PCI DSS",
      "cert.pciDesc": "Payment Card Industry Data Security",
      "cert.gdpr": "GDPR",
      "cert.gdprDesc": "General Data Protection Regulation",
      
      // Partnerships
      "partners.title": "Global Partnerships",
      "partners.subtitle": "We collaborate with world-leading cybersecurity vendors and technology alliances to deliver cutting-edge protection for your organization.",
      
      // CTA
      "cta.title": "Ready to Secure Your Digital Future?",
      "cta.subtitle": "Let's discuss how we can protect your organization with our proven cybersecurity solutions.",
      "cta.button": "Contact Us Today",
      
      // Blog
      "blog.title": "Security Insights & Updates",
      "blog.subtitle": "Stay informed about the latest cybersecurity threats, trends, and best practices from leading sources.",
      "blog.loading": "Loading latest articles...",
      "blog.noArticles": "No articles available at the moment.",
      "blog.readMore": "Read More",
      "blog.newsletter": "Subscribe to Security Updates",
      "blog.newsletterDesc": "Get the latest cybersecurity insights delivered directly to your inbox.",
      "blog.emailPlaceholder": "Enter your email",
      "blog.subscribe": "Subscribe",
      
      // Contact
      "contact.title": "Get In Touch",
      "contact.subtitle": "Let's discuss how we can protect your organization with our cybersecurity solutions.",
      "contact.info": "Contact Information",
      "contact.infoDesc": "Reach out to our security experts. We're here to help you protect your digital assets.",
      "contact.email": "Email",
      "contact.phone": "Phone",
      "contact.address": "Office",
      "contact.officeHours": "Office Hours",
      "contact.emergency": "Emergency support available 24/7",
      "contact.formTitle": "Send Us a Message",
      "contact.name": "Full Name",
      "contact.namePlaceholder": "John Doe",
      "contact.emailAddress": "Email Address",
      "contact.emailPlaceholder": "john@company.com",
      "contact.company": "Company",
      "contact.companyPlaceholder": "Your Company",
      "contact.service": "Service Interest",
      "contact.serviceSelect": "Select a service",
      "contact.message": "Message",
      "contact.messagePlaceholder": "Tell us about your security needs...",
      "contact.submit": "Send Message",
      "contact.sending": "Sending...",
      "contact.success": "Thank you for your message! We'll get back to you within 24 hours.",
      "contact.error": "Failed to submit the form. Please try again or contact us directly via email.",
      "contact.rateLimit": "Too many submission attempts. Please wait a moment before trying again.",
      "contact.mapTitle": "Our Location",
      
      // Footer
      "footer.description": "Protecting digital assets with cutting-edge cybersecurity solutions.",
      "footer.quickLinks": "Quick Links",
      "footer.services": "Services",
      "footer.contact": "Contact",
      "footer.copyright": "© 2025 SULH Cybersecurity. All rights reserved.",
      
      // Penetration Testing Page
      "pentest.hero.title": "Penetration Testing Services",
      "pentest.hero.subtitle": "Proactive security testing to identify and remediate vulnerabilities before attackers exploit them. Strengthening your corporate defense through systematic assessment.",
      "pentest.types.title": "Types of Penetration Testing",
      "pentest.types.network": "Network Penetration Testing",
      "pentest.types.networkDesc": "Comprehensive assessment of network infrastructure, firewalls, routers, and switches to identify exploitable vulnerabilities.",
      "pentest.types.web": "Web Application Testing",
      "pentest.types.webDesc": "In-depth security analysis of web applications including OWASP Top 10 vulnerabilities, injection attacks, and authentication flaws.",
      "pentest.types.mobile": "Mobile Application Testing",
      "pentest.types.mobileDesc": "Security testing for iOS and Android applications, including data storage, communication, and authentication mechanisms.",
      "pentest.types.wireless": "Wireless Security Testing",
      "pentest.types.wirelessDesc": "Assessment of wireless networks, encryption protocols, access points, and rogue device detection.",
      "pentest.types.social": "Social Engineering",
      "pentest.types.socialDesc": "Simulated phishing campaigns and social engineering attacks to test human vulnerability and security awareness.",
      "pentest.methodologies.title": "Industry-Standard Methodologies",
      "pentest.methodologies.subtitle": "Our penetration testing follows globally recognized frameworks to ensure comprehensive and reliable results.",
      "pentest.process.title": "Our Penetration Testing Process",
      "pentest.process.step1": "Planning & Reconnaissance",
      "pentest.process.step1Desc": "Define scope, objectives, and gather intelligence about target systems.",
      "pentest.process.step2": "Scanning & Enumeration",
      "pentest.process.step2Desc": "Identify live hosts, open ports, services, and potential entry points.",
      "pentest.process.step3": "Vulnerability Assessment",
      "pentest.process.step3Desc": "Analyze systems for known vulnerabilities and security weaknesses.",
      "pentest.process.step4": "Exploitation",
      "pentest.process.step4Desc": "Attempt to exploit identified vulnerabilities to gain access.",
      "pentest.process.step5": "Post-Exploitation",
      "pentest.process.step5Desc": "Determine the value of compromised systems and maintain access.",
      "pentest.process.step6": "Reporting",
      "pentest.process.step6Desc": "Comprehensive documentation of findings, risks, and remediation steps.",
      "pentest.benefits.title": "Strengthen Your Corporate Defense",
      "pentest.benefits.subtitle": "Penetration testing is essential for maintaining a robust security posture. Our comprehensive approach helps you:",
      "pentest.benefits.vuln": "Identify Critical Vulnerabilities",
      "pentest.benefits.vulnDesc": "Discover security weaknesses before malicious actors do",
      "pentest.benefits.comply": "Comply with Regulations",
      "pentest.benefits.complyDesc": "Meet PCI DSS, GDPR, and ISO 27001 requirements",
      "pentest.benefits.validate": "Validate Security Controls",
      "pentest.benefits.validateDesc": "Test the effectiveness of existing security measures",
      "pentest.benefits.prioritize": "Prioritize Remediation",
      "pentest.benefits.prioritizeDesc": "Understand which vulnerabilities pose the greatest risk",
      "pentest.reporting.title": "Comprehensive Reporting",
      "pentest.reporting.subtitle": "Our detailed reports include:",
      "pentest.reporting.item1": "Executive summary for leadership",
      "pentest.reporting.item2": "Technical findings with evidence",
      "pentest.reporting.item3": "Risk ratings and CVSS scores",
      "pentest.reporting.item4": "Step-by-step remediation guidance",
      "pentest.reporting.item5": "Compliance mapping",
      "pentest.reporting.item6": "Re-testing recommendations",
      "pentest.methodology.owasp": "Open Web Application Security Project standards for web application security testing.",
      "pentest.methodology.osstmm": "Open Source Security Testing Methodology Manual for comprehensive security analysis.",
      "pentest.methodology.ptes": "Penetration Testing Execution Standard for systematic penetration testing.",
      "pentest.methodology.nist": "National Institute of Standards and Technology cybersecurity framework.",
      "pentest.cta.title": "Request a Penetration Test",
      "pentest.cta.subtitle": "Get started with a comprehensive security assessment tailored to your organization's needs.",
      "pentest.cta.button": "Contact Our Security Team",
      
      // Services Page
      "services.hero.title": "Comprehensive Cybersecurity Services",
      "services.hero.subtitle": "Protecting your organization with industry-leading security solutions tailored to your unique needs.",
      "services.keyFeatures": "Key Features",
      "services.learnMore": "Learn More",
      "services.getStarted": "Get Started",
      "services.why.title": "Why Choose SULH?",
      "services.why.experience": "Years of Experience",
      "services.why.experienceDesc": "Industry expertise protecting organizations worldwide",
      "services.why.certified": "Certified Excellence",
      "services.why.certifiedDesc": "Meeting the highest international security standards",
      "services.why.tse": "TSE-Integrated",
      "services.why.tseDesc": "Turkish Standards Institute certified operations",
      "services.why.support": "Support Available",
      "services.why.supportDesc": "Round-the-clock security monitoring and assistance",
      "services.cta.title": "Ready to Strengthen Your Security?",
      "services.cta.subtitle": "Let our experts assess your security needs and recommend the best solutions for your organization.",
      "services.cta.button": "Schedule a Consultation",
      
      // Individual Services
      "services.pentest.title": "Penetration Testing",
      "services.pentest.short": "Identify vulnerabilities before attackers do",
      "services.pentest.desc": "Our comprehensive penetration testing services simulate real-world attacks to identify security weaknesses in your systems, applications, and networks. We follow industry-standard methodologies including OWASP, OSSTMM, and PTES to ensure thorough assessment.",
      "services.pentest.feat1": "Network Penetration Testing",
      "services.pentest.feat2": "Web Application Security Testing",
      "services.pentest.feat3": "Mobile Application Testing",
      "services.pentest.feat4": "Wireless Security Assessment",
      "services.pentest.feat5": "Social Engineering Tests",
      "services.pentest.feat6": "Detailed Vulnerability Reports",
      
      "services.siem.title": "SIEM Solutions",
      "services.siem.short": "Real-time threat detection and response",
      "services.siem.desc": "Security Information and Event Management (SIEM) solutions provide real-time monitoring, analysis, and correlation of security events across your entire infrastructure. Our SIEM implementation helps you detect, investigate, and respond to threats quickly.",
      "services.siem.feat1": "Real-time Security Monitoring",
      "services.siem.feat2": "Log Management & Correlation",
      "services.siem.feat3": "Threat Intelligence Integration",
      "services.siem.feat4": "Automated Incident Response",
      "services.siem.feat5": "Compliance Reporting",
      "services.siem.feat6": "24/7 SOC Support",
      
      "services.idsips.title": "IDS/IPS",
      "services.idsips.short": "Advanced intrusion detection and prevention",
      "services.idsips.desc": "Our Intrusion Detection and Prevention Systems (IDS/IPS) provide comprehensive network security by identifying and blocking malicious activities in real-time. Protect your infrastructure from both known and zero-day threats.",
      "services.idsips.feat1": "Network Traffic Analysis",
      "services.idsips.feat2": "Signature-based Detection",
      "services.idsips.feat3": "Anomaly-based Detection",
      "services.idsips.feat4": "Automated Threat Blocking",
      "services.idsips.feat5": "Custom Rule Configuration",
      "services.idsips.feat6": "Integration with Security Stack",
      
      "services.vuln.title": "Vulnerability Assessment",
      "services.vuln.short": "Systematic security weakness evaluation",
      "services.vuln.desc": "Regular vulnerability assessments help identify, classify, and prioritize security weaknesses in your IT infrastructure. Our systematic approach ensures comprehensive coverage of all assets, from servers and workstations to cloud resources.",
      "services.vuln.feat1": "Automated Vulnerability Scanning",
      "services.vuln.feat2": "Manual Security Analysis",
      "services.vuln.feat3": "Risk Prioritization & Scoring",
      "services.vuln.feat4": "Remediation Guidance",
      "services.vuln.feat5": "Continuous Monitoring",
      "services.vuln.feat6": "Compliance Mapping",
      
      "services.training.title": "Security Awareness Training",
      "services.training.short": "Building your human firewall",
      "services.training.desc": "Employees are often the weakest link in cybersecurity. Our comprehensive security awareness training programs educate your team about threats, best practices, and proper incident response, transforming them into your first line of defense.",
      "services.training.feat1": "Phishing Simulation Campaigns",
      "services.training.feat2": "Interactive Training Modules",
      "services.training.feat3": "Role-based Security Training",
      "services.training.feat4": "Incident Reporting Procedures",
      "services.training.feat5": "Regular Security Updates",
      "services.training.feat6": "Compliance Training (GDPR, PCI DSS)",
      
      "services.malware.title": "Reverse Engineering & Malware Analysis",
      "services.malware.short": "Advanced threat analysis and protection",
      "services.malware.desc": "Our reverse engineering and malware analysis services help identify, analyze, and neutralize sophisticated threats. We dissect malicious code to understand attack vectors, develop countermeasures, and protect your organization from similar future attacks.",
      "services.malware.feat1": "Malware Reverse Engineering",
      "services.malware.feat2": "Behavioral Analysis & Sandboxing",
      "services.malware.feat3": "Code Decompilation & Analysis",
      "services.malware.feat4": "Threat Intelligence Extraction",
      "services.malware.feat5": "Custom Signature Development",
      "services.malware.feat6": "Incident Recovery & Remediation",
      
      // Threat Map Page
      "threatMap.hero.title": "Live Cyber Threat Map",
      "threatMap.hero.subtitle": "Real-time visualization of global cyber threats and attacks happening around the world.",
      "threatMap.info.realtime": "Real-Time Detection",
      "threatMap.info.realtimeDesc": "Monitor cyber attacks as they happen across the globe",
      "threatMap.info.global": "Global Coverage",
      "threatMap.info.globalDesc": "Threat data from countries and regions worldwide",
      "threatMap.info.analytics": "Attack Analytics",
      "threatMap.info.analyticsDesc": "Detailed statistics on attack types and sources",
      "threatMap.about.title": "About This Map",
      "threatMap.about.desc1": "The Kaspersky Cyberthreat real-time map shows how and where cyberattacks and threats are taking place all around the world at any given moment. The data is processed by Kaspersky Security Network (KSN), a cloud-based system that receives and processes complex threat data from millions of voluntary participants around the globe.",
      "threatMap.about.desc2": "The map displays a sample of anonymized threat data detected and blocked by Kaspersky products. It does not show all threats, but provides a representative view of the current threat landscape.",
      "threatMap.understanding.title": "Understanding the Threat Map",
      "threatMap.attackTypes.title": "Attack Types",
      "threatMap.attackTypes.web": "Web Threats:",
      "threatMap.attackTypes.webDesc": "Malicious websites and phishing attempts",
      "threatMap.attackTypes.network": "Network Attacks:",
      "threatMap.attackTypes.networkDesc": "DDoS, port scanning, and intrusions",
      "threatMap.attackTypes.local": "Local Threats:",
      "threatMap.attackTypes.localDesc": "Malware detected on devices",
      "threatMap.attackTypes.email": "Email Threats:",
      "threatMap.attackTypes.emailDesc": "Spam and malicious attachments",
      "threatMap.howToRead.title": "How to Read the Map",
      "threatMap.howToRead.line1": "Lines represent attack paths from source to target countries",
      "threatMap.howToRead.line2": "Color intensity indicates the volume of attacks",
      "threatMap.howToRead.line3": "Statistics update in real-time based on KSN data",
      "threatMap.howToRead.line4": "Click on countries to view detailed threat information",
    }
  },
  tr: {
    translation: {
      // Navigation
      "nav.home": "Ana Sayfa",
      "nav.services": "Hizmetler",
      "nav.penetration": "Penetrasyon Testi",
      "nav.threatMap": "Tehdit Haritası",
      "nav.blog": "Blog",
      "nav.contact": "İletişim",
      
      // Hero Section
      "hero.title": "Dijital Varlıklarınızı",
      "hero.titleHighlight": "Mükemmellikle Koruyoruz",
      "hero.subtitle": "İnovasyon, güvenilirlik ve küresel uzmanlık ile desteklenen lider siber güvenlik çözümleri. Dünya çapında kurumların güvendiği hizmetler.",
      "hero.cta1": "Hemen Başlayın",
      "hero.cta2": "Hizmetleri Keşfedin",
      
      // Stats
      "stats.clients": "Korunan Müşteri",
      "stats.detection": "Tehdit Tespiti",
      "stats.countries": "Hizmet Verilen Ülke",
      "stats.monitoring": "Güvenlik İzleme",
      
      // About Section
      "about.title": "SULH Siber Güvenlik Hakkında",
      "about.desc1": "Gelişen dijital tehditlere karşı kurumları korumaya adanmış, küresel olarak tanınan bir siber güvenlik firmasıyız. TSE entegre bir şirket olarak en yüksek güvenlik ve uyumluluk standartlarını koruyoruz.",
      "about.desc2": "ISO 27001 sertifikamız bilgi güvenliği yönetimine olan bağlılığımızı gösterirken, PCI DSS ve GDPR uyumluluğumuz uluslararası düzenleyici standartları karşıladığımızı garanti eder.",
      "about.desc3": "Önde gelen uluslararası siber güvenlik ortaklarıyla işbirliği yaparak, işletme altyapınızı, verilerinizi ve itibarınızı koruyan son teknoloji çözümler sunuyoruz.",
      "about.cta": "Bizimle Ortak Olun",
      "about.commitment": "Taahhütlerimiz",
      "about.cert1": "ISO 27001 Sertifikalı Mükemmellik",
      "about.cert2": "TSE Entegre Operasyonlar",
      "about.cert3": "PCI DSS Uyumlu Çözümler",
      "about.cert4": "GDPR Veri Koruma",
      "about.cert5": "Küresel Ortaklık Ağı",
      
      // Services
      "services.title": "Hizmetlerimiz",
      "services.subtitle": "Kuruluşunuzu korumak için özel olarak hazırlanmış kapsamlı siber güvenlik çözümleri",
      "services.pentest": "Penetrasyon Testi",
      "services.pentestDesc": "Saldırganlardan önce güvenlik açıklarını tespit etmek için kapsamlı güvenlik değerlendirmeleri.",
      "services.siem": "SIEM Çözümleri",
      "services.siemDesc": "Tehdit tespiti için gerçek zamanlı güvenlik izleme ve olay yönetimi.",
      "services.idsips": "IDS/IPS",
      "services.idsipsDesc": "Ağ güvenliği için gelişmiş saldırı tespit ve önleme sistemleri.",
      "services.vuln": "Zafiyet Analizi",
      "services.vulnDesc": "Altyapınızdaki güvenlik zayıflıklarının sistematik değerlendirmesi.",
      "services.training": "Güvenlik Farkındalık Eğitimi",
      "services.trainingDesc": "Sosyal mühendislik saldırılarını önlemek için ekibinizi bilgiyle güçlendirin.",
      "services.malware": "Tersine Mühendislik ve Kötü Amaçlı Yazılım Analizi",
      "services.malwareDesc": "Gelişmiş kötü amaçlı yazılımları tespit etmek ve etkisiz hale getirmek için ileri düzey tehdit analizi.",
      "services.learnMore": "Hizmetlerimiz Hakkında Daha Fazla Bilgi",
      
      // Certifications
      "cert.title": "Uyumluluk ve Sertifikalar",
      "cert.subtitle": "Siber güvenlik ve veri koruma için en yüksek uluslararası standartları karşılama",
      "cert.iso": "ISO 27001",
      "cert.isoDesc": "Bilgi Güvenliği Yönetimi",
      "cert.tse": "TSE Entegrasyonu",
      "cert.tseDesc": "Türk Standardları Enstitüsü",
      "cert.pci": "PCI DSS",
      "cert.pciDesc": "Ödeme Kartı Endüstrisi Veri Güvenliği",
      "cert.gdpr": "GDPR",
      "cert.gdprDesc": "Genel Veri Koruma Yönetmeliği",
      
      // Partnerships
      "partners.title": "Küresel Ortaklıklar",
      "partners.subtitle": "Kuruluşunuza en son teknoloji koruma sunmak için dünya çapında lider siber güvenlik satıcıları ve teknoloji ittifaklarıyla işbirliği yapıyoruz.",
      
      // CTA
      "cta.title": "Dijital Geleceğinizi Güvence Altına Almaya Hazır mısınız?",
      "cta.subtitle": "Kanıtlanmış siber güvenlik çözümlerimizle kuruluşunuzu nasıl koruyabileceğimizi konuşalım.",
      "cta.button": "Bugün İletişime Geçin",
      
      // Blog (titles only, content stays in English)
      "blog.title": "Güvenlik İçgörüleri ve Güncellemeler",
      "blog.subtitle": "Önde gelen kaynaklardan en son siber güvenlik tehditleri, trendler ve en iyi uygulamalar hakkında bilgi sahibi olun.",
      "blog.loading": "Son makaleler yükleniyor...",
      "blog.noArticles": "Şu anda makale mevcut değil.",
      "blog.readMore": "Devamını Oku",
      "blog.newsletter": "Güvenlik Güncellemelerine Abone Olun",
      "blog.newsletterDesc": "En son siber güvenlik içgörülerini doğrudan gelen kutunuza alın.",
      "blog.emailPlaceholder": "E-posta adresinizi girin",
      "blog.subscribe": "Abone Ol",
      
      // Contact
      "contact.title": "İletişime Geçin",
      "contact.subtitle": "Siber güvenlik çözümlerimizle kuruluşunuzu nasıl koruyabileceğimizi konuşalım.",
      "contact.info": "İletişim Bilgileri",
      "contact.infoDesc": "Güvenlik uzmanlarımıza ulaşın. Dijital varlıklarınızı korumanıza yardımcı olmak için buradayız.",
      "contact.email": "E-posta",
      "contact.phone": "Telefon",
      "contact.address": "Ofis",
      "contact.officeHours": "Çalışma Saatleri",
      "contact.emergency": "7/24 acil destek mevcut",
      "contact.formTitle": "Bize Mesaj Gönderin",
      "contact.name": "Ad Soyad",
      "contact.namePlaceholder": "Ahmet Yılmaz",
      "contact.emailAddress": "E-posta Adresi",
      "contact.emailPlaceholder": "ahmet@sirket.com",
      "contact.company": "Şirket",
      "contact.companyPlaceholder": "Şirket Adınız",
      "contact.service": "İlgilendiğiniz Hizmet",
      "contact.serviceSelect": "Bir hizmet seçin",
      "contact.message": "Mesaj",
      "contact.messagePlaceholder": "Güvenlik ihtiyaçlarınız hakkında bize bilgi verin...",
      "contact.submit": "Mesaj Gönder",
      "contact.sending": "Gönderiliyor...",
      "contact.success": "Mesajınız için teşekkür ederiz! 24 saat içinde size geri döneceğiz.",
      "contact.error": "Form gönderilemedi. Lütfen tekrar deneyin veya doğrudan e-posta ile iletişime geçin.",
      "contact.rateLimit": "Çok fazla gönderim denemesi. Lütfen tekrar denemeden önce bir süre bekleyin.",
      "contact.mapTitle": "Konumumuz",
      
      // Footer
      "footer.description": "Son teknoloji siber güvenlik çözümleri ile dijital varlıkları koruyoruz.",
      "footer.quickLinks": "Hızlı Bağlantılar",
      "footer.services": "Hizmetler",
      "footer.contact": "İletişim",
      "footer.copyright": "© 2025 SULH Siber Güvenlik. Tüm hakları saklıdır.",
      
      // Penetration Testing Page
      "pentest.hero.title": "Penetrasyon Testi Hizmetleri",
      "pentest.hero.subtitle": "Saldırganlar sömürmeden önce güvenlik açıklarını tespit etmek ve gidermek için proaktif güvenlik testi. Sistematik değerlendirme ile kurumsal savunmanızı güçlendirme.",
      "pentest.types.title": "Penetrasyon Testi Türleri",
      "pentest.types.network": "Ağ Penetrasyon Testi",
      "pentest.types.networkDesc": "Ağ altyapısı, güvenlik duvarları, yönlendiriciler ve anahtarların kapsamlı değerlendirmesi ile istismar edilebilir güvenlik açıklarının tespiti.",
      "pentest.types.web": "Web Uygulama Testi",
      "pentest.types.webDesc": "OWASP Top 10 güvenlik açıkları, enjeksiyon saldırıları ve kimlik doğrulama hatalarını içeren web uygulamalarının derinlemesine güvenlik analizi.",
      "pentest.types.mobile": "Mobil Uygulama Testi",
      "pentest.types.mobileDesc": "Veri depolama, iletişim ve kimlik doğrulama mekanizmalarını içeren iOS ve Android uygulamaları için güvenlik testi.",
      "pentest.types.wireless": "Kablosuz Güvenlik Testi",
      "pentest.types.wirelessDesc": "Kablosuz ağların, şifreleme protokollerinin, erişim noktalarının ve sahte cihaz tespitinin değerlendirilmesi.",
      "pentest.types.social": "Sosyal Mühendislik",
      "pentest.types.socialDesc": "İnsan güvenlik açıklarını ve güvenlik farkındalığını test etmek için simüle edilmiş phishing kampanyaları ve sosyal mühendislik saldırıları.",
      "pentest.methodologies.title": "Endüstri Standardı Metodolojiler",
      "pentest.methodologies.subtitle": "Penetrasyon testimiz, kapsamlı ve güvenilir sonuçlar sağlamak için küresel olarak tanınan çerçeveleri takip eder.",
      "pentest.process.title": "Penetrasyon Testi Sürecimiz",
      "pentest.process.step1": "Planlama ve Keşif",
      "pentest.process.step1Desc": "Kapsam, hedefleri tanımla ve hedef sistemler hakkında istihbarat topla.",
      "pentest.process.step2": "Tarama ve Numaralandırma",
      "pentest.process.step2Desc": "Canlı hostları, açık portları, servisleri ve potansiyel giriş noktalarını tanımla.",
      "pentest.process.step3": "Zafiyet Değerlendirmesi",
      "pentest.process.step3Desc": "Bilinen güvenlik açıkları ve güvenlik zayıflıkları için sistemleri analiz et.",
      "pentest.process.step4": "İstismar",
      "pentest.process.step4Desc": "Erişim elde etmek için tespit edilen güvenlik açıklarını istismar etmeye çalış.",
      "pentest.process.step5": "İstismar Sonrası",
      "pentest.process.step5Desc": "Ele geçirilen sistemlerin değerini belirle ve erişimi sürdür.",
      "pentest.process.step6": "Raporlama",
      "pentest.process.step6Desc": "Bulgular, riskler ve düzeltme adımlarının kapsamlı dokümantasyonu.",
      "pentest.benefits.title": "Kurumsal Savunmanızı Güçlendirin",
      "pentest.benefits.subtitle": "Penetrasyon testi, sağlam bir güvenlik duruşu sürdürmek için gereklidir. Kapsamlı yaklaşımımız size yardımcı olur:",
      "pentest.benefits.vuln": "Kritik Güvenlik Açıklarını Tespit Edin",
      "pentest.benefits.vulnDesc": "Kötü niyetli aktörlerden önce güvenlik zayıflıklarını keşfedin",
      "pentest.benefits.comply": "Düzenlemelere Uyum Sağlayın",
      "pentest.benefits.complyDesc": "PCI DSS, GDPR ve ISO 27001 gereksinimlerini karşılayın",
      "pentest.benefits.validate": "Güvenlik Kontrollerini Doğrulayın",
      "pentest.benefits.validateDesc": "Mevcut güvenlik önlemlerinin etkinliğini test edin",
      "pentest.benefits.prioritize": "Düzeltmeye Öncelik Verin",
      "pentest.benefits.prioritizeDesc": "Hangi güvenlik açıklarının en büyük riski oluşturduğunu anlayın",
      "pentest.reporting.title": "Kapsamlı Raporlama",
      "pentest.reporting.subtitle": "Detaylı raporlarımız şunları içerir:",
      "pentest.reporting.item1": "Liderlik için yönetici özeti",
      "pentest.reporting.item2": "Kanıtlarla teknik bulgular",
      "pentest.reporting.item3": "Risk derecelendirmeleri ve CVSS skorları",
      "pentest.reporting.item4": "Adım adım düzeltme kılavuzu",
      "pentest.reporting.item5": "Uyumluluk eşleştirme",
      "pentest.reporting.item6": "Yeniden test önerileri",
      "pentest.methodology.owasp": "Web uygulama güvenlik testi için Açık Web Uygulama Güvenliği Projesi standartları.",
      "pentest.methodology.osstmm": "Kapsamlı güvenlik analizi için Açık Kaynak Güvenlik Test Metodolojisi Kılavuzu.",
      "pentest.methodology.ptes": "Sistematik penetrasyon testi için Penetrasyon Testi Uygulama Standardı.",
      "pentest.methodology.nist": "Ulusal Standartlar ve Teknoloji Enstitüsü siber güvenlik çerçevesi.",
      "pentest.cta.title": "Penetrasyon Testi Talep Edin",
      "pentest.cta.subtitle": "Kuruluşunuzun ihtiyaçlarına göre özelleştirilmiş kapsamlı bir güvenlik değerlendirmesi ile başlayın.",
      "pentest.cta.button": "Güvenlik Ekibimizle İletişime Geçin",
      
      // Services Page
      "services.hero.title": "Kapsamlı Siber Güvenlik Hizmetleri",
      "services.hero.subtitle": "Benzersiz ihtiyaçlarınıza uygun, sektör lideri güvenlik çözümleriyle kuruluşunuzu koruma.",
      "services.keyFeatures": "Temel Özellikler",
      "services.learnMore": "Daha Fazla Bilgi",
      "services.getStarted": "Hemen Başlayın",
      "services.why.title": "Neden SULH'u Seçmelisiniz?",
      "services.why.experience": "Yıllık Deneyim",
      "services.why.experienceDesc": "Dünya çapında kuruluşları koruyan sektör uzmanlığı",
      "services.why.certified": "Sertifikalı Mükemmellik",
      "services.why.certifiedDesc": "En yüksek uluslararası güvenlik standartlarını karşılama",
      "services.why.tse": "TSE Entegre",
      "services.why.tseDesc": "Türk Standardları Enstitüsü sertifikalı operasyonlar",
      "services.why.support": "Destek Mevcut",
      "services.why.supportDesc": "7/24 güvenlik izleme ve yardım",
      "services.cta.title": "Güvenliğinizi Güçlendirmeye Hazır mısınız?",
      "services.cta.subtitle": "Uzmanlarımızın güvenlik ihtiyaçlarınızı değerlendirmesine ve kuruluşunuz için en iyi çözümleri önermesine izin verin.",
      "services.cta.button": "Bir Danışma Planlayın",
      
      // Individual Services
      "services.pentest.title": "Penetrasyon Testi",
      "services.pentest.short": "Saldırganlardan önce güvenlik açıklarını tespit edin",
      "services.pentest.desc": "Kapsamlı penetrasyon testi hizmetlerimiz, sistemleriniz, uygulamalarınız ve ağlarınızdaki güvenlik zayıflıklarını tespit etmek için gerçek dünya saldırılarını simüle eder. Kapsamlı değerlendirme sağlamak için OWASP, OSSTMM ve PTES dahil olmak üzere endüstri standardı metodolojileri takip ediyoruz.",
      "services.pentest.feat1": "Ağ Penetrasyon Testi",
      "services.pentest.feat2": "Web Uygulama Güvenlik Testi",
      "services.pentest.feat3": "Mobil Uygulama Testi",
      "services.pentest.feat4": "Kablosuz Güvenlik Değerlendirmesi",
      "services.pentest.feat5": "Sosyal Mühendislik Testleri",
      "services.pentest.feat6": "Detaylı Zafiyet Raporları",
      
      "services.siem.title": "SIEM Çözümleri",
      "services.siem.short": "Gerçek zamanlı tehdit tespiti ve müdahale",
      "services.siem.desc": "Güvenlik Bilgi ve Olay Yönetimi (SIEM) çözümleri, tüm altyapınız genelinde güvenlik olaylarının gerçek zamanlı izlenmesi, analizi ve ilişkilendirilmesini sağlar. SIEM uygulamamız, tehditleri hızlı bir şekilde tespit etmenize, araştırmanıza ve bunlara yanıt vermenize yardımcı olur.",
      "services.siem.feat1": "Gerçek Zamanlı Güvenlik İzleme",
      "services.siem.feat2": "Log Yönetimi ve İlişkilendirme",
      "services.siem.feat3": "Tehdit İstihbaratı Entegrasyonu",
      "services.siem.feat4": "Otomatik Olay Müdahalesi",
      "services.siem.feat5": "Uyumluluk Raporlaması",
      "services.siem.feat6": "7/24 SOC Desteği",
      
      "services.idsips.title": "IDS/IPS",
      "services.idsips.short": "Gelişmiş saldırı tespit ve önleme",
      "services.idsips.desc": "Saldırı Tespit ve Önleme Sistemlerimiz (IDS/IPS), kötü amaçlı faaliyetleri gerçek zamanlı olarak tespit ederek ve engelleyerek kapsamlı ağ güvenliği sağlar. Altyapınızı hem bilinen hem de sıfır gün tehditlerine karşı koruyun.",
      "services.idsips.feat1": "Ağ Trafik Analizi",
      "services.idsips.feat2": "İmza Tabanlı Tespit",
      "services.idsips.feat3": "Anomali Tabanlı Tespit",
      "services.idsips.feat4": "Otomatik Tehdit Engelleme",
      "services.idsips.feat5": "Özel Kural Yapılandırması",
      "services.idsips.feat6": "Güvenlik Yığını ile Entegrasyon",
      
      "services.vuln.title": "Zafiyet Değerlendirmesi",
      "services.vuln.short": "Sistematik güvenlik zayıflığı değerlendirmesi",
      "services.vuln.desc": "Düzenli zafiyet değerlendirmeleri, BT altyapınızdaki güvenlik zayıflıklarını tanımlamanıza, sınıflandırmanıza ve önceliklendirmenize yardımcı olur. Sistematik yaklaşımımız, sunuculardan ve iş istasyonlarından bulut kaynaklarına kadar tüm varlıkların kapsamlı bir şekilde kapsanmasını sağlar.",
      "services.vuln.feat1": "Otomatik Zafiyet Taraması",
      "services.vuln.feat2": "Manuel Güvenlik Analizi",
      "services.vuln.feat3": "Risk Önceliklendirme ve Puanlama",
      "services.vuln.feat4": "Düzeltme Kılavuzu",
      "services.vuln.feat5": "Sürekli İzleme",
      "services.vuln.feat6": "Uyumluluk Eşleştirme",
      
      "services.training.title": "Güvenlik Farkındalık Eğitimi",
      "services.training.short": "İnsan güvenlik duvarınızı oluşturma",
      "services.training.desc": "Çalışanlar genellikle siber güvenliğin en zayıf halkasıdır. Kapsamlı güvenlik farkındalığı eğitim programlarımız, ekibinizi tehditler, en iyi uygulamalar ve uygun olay müdahalesi konusunda eğiterek onları ilk savunma hattınıza dönüştürür.",
      "services.training.feat1": "Phishing Simülasyon Kampanyaları",
      "services.training.feat2": "Etkileşimli Eğitim Modülleri",
      "services.training.feat3": "Rol Tabanlı Güvenlik Eğitimi",
      "services.training.feat4": "Olay Raporlama Prosedürleri",
      "services.training.feat5": "Düzenli Güvenlik Güncellemeleri",
      "services.training.feat6": "Uyumluluk Eğitimi (GDPR, PCI DSS)",
      
      "services.malware.title": "Tersine Mühendislik ve Kötü Amaçlı Yazılım Analizi",
      "services.malware.short": "İleri düzey tehdit analizi ve koruma",
      "services.malware.desc": "Tersine mühendislik ve kötü amaçlı yazılım analiz hizmetlerimiz, gelişmiş tehditleri tanımlamanıza, analiz etmenize ve etkisiz hale getirmenize yardımcı olur. Saldırı vektörlerini anlamak, karşı önlemler geliştirmek ve kuruluşunuzu gelecekteki benzer saldırılara karşı korumak için kötü amaçlı kodu parçalara ayırıyoruz.",
      "services.malware.feat1": "Kötü Amaçlı Yazılım Tersine Mühendisliği",
      "services.malware.feat2": "Davranışsal Analiz ve Sandbox",
      "services.malware.feat3": "Kod Derleme ve Analiz",
      "services.malware.feat4": "Tehdit İstihbaratı Çıkarımı",
      "services.malware.feat5": "Özel İmza Geliştirme",
      "services.malware.feat6": "Olay Kurtarma ve Düzeltme",
      
      // Threat Map Page
      "threatMap.hero.title": "Canlı Siber Tehdit Haritası",
      "threatMap.hero.subtitle": "Dünya çapında gerçekleşen küresel siber tehditlerin ve saldırıların gerçek zamanlı görselleştirmesi.",
      "threatMap.info.realtime": "Gerçek Zamanlı Tespit",
      "threatMap.info.realtimeDesc": "Dünya çapında gerçekleşen siber saldırıları izleyin",
      "threatMap.info.global": "Küresel Kapsama",
      "threatMap.info.globalDesc": "Dünya çapındaki ülkeler ve bölgelerden tehdit verileri",
      "threatMap.info.analytics": "Saldırı Analitiği",
      "threatMap.info.analyticsDesc": "Saldırı türleri ve kaynakları hakkında detaylı istatistikler",
      "threatMap.about.title": "Bu Harita Hakkında",
      "threatMap.about.desc1": "Kaspersky Siber Tehdit gerçek zamanlı haritası, siber saldırıların ve tehditlerin dünyanın herhangi bir anında nerede ve nasıl gerçekleştiğini gösterir. Veriler, dünya çapında milyonlarca gönüllü katılımcıdan karmaşık tehdit verilerini alan ve işleyen bulut tabanlı bir sistem olan Kaspersky Güvenlik Ağı (KSN) tarafından işlenir.",
      "threatMap.about.desc2": "Harita, Kaspersky ürünleri tarafından tespit edilen ve engellenen anonim tehdit verilerinin bir örneğini görüntüler. Tüm tehditleri göstermez, ancak mevcut tehdit ortamının temsili bir görünümünü sağlar.",
      "threatMap.understanding.title": "Tehdit Haritasını Anlama",
      "threatMap.attackTypes.title": "Saldırı Türleri",
      "threatMap.attackTypes.web": "Web Tehditleri:",
      "threatMap.attackTypes.webDesc": "Kötü amaçlı web siteleri ve phishing girişimleri",
      "threatMap.attackTypes.network": "Ağ Saldırıları:",
      "threatMap.attackTypes.networkDesc": "DDoS, port tarama ve saldırılar",
      "threatMap.attackTypes.local": "Yerel Tehditler:",
      "threatMap.attackTypes.localDesc": "Cihazlarda tespit edilen kötü amaçlı yazılımlar",
      "threatMap.attackTypes.email": "E-posta Tehditleri:",
      "threatMap.attackTypes.emailDesc": "Spam ve kötü amaçlı ekler",
      "threatMap.howToRead.title": "Haritayı Nasıl Okursunuz",
      "threatMap.howToRead.line1": "Çizgiler, kaynak ülkelerden hedef ülkelere saldırı yollarını temsil eder",
      "threatMap.howToRead.line2": "Renk yoğunluğu saldırı hacmini gösterir",
      "threatMap.howToRead.line3": "İstatistikler KSN verilerine göre gerçek zamanlı güncellenir",
      "threatMap.howToRead.line4": "Detaylı tehdit bilgilerini görüntülemek için ülkelere tıklayın",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;